/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */
import type { Cuid } from './cuid'
import type { HlsStatus } from './hlsStatus'
import type { ScenarioVideoMetadata } from './scenarioVideoMetadata'
import type { ScenarioVideoSurveyId } from './scenarioVideoSurveyId'
import type { VideoChapter } from './videoChapter'
import type { VideoStatus } from './videoStatus'

export interface ScenarioVideo {
  updatedAt: string
  createdAt: string
  /**
   * チャプター（目次）。`[{ time: 秒, title: 見出し }]`。ワイド型で使う（ADR-0016）
   * @nullable
   */
  chapters: VideoChapter[] | null
  /**
   * 紐づけるアンケートテンプレ（1動画=1テンプレ・共有可・ADR-0015）
   * @nullable
   */
  surveyId: ScenarioVideoSurveyId
  /** @nullable */
  ctaLabel: string | null
  /** @nullable */
  ctaUrl: string | null
  showTitle: boolean
  displayOrder: number
  isUnlisted: boolean
  isPublished: boolean
  /** @nullable */
  videoTextTemplateId2: string | null
  /** @nullable */
  performerTemplateId2: string | null
  /** @nullable */
  videoTextTemplateId: string | null
  /** @nullable */
  performerTemplateId: string | null
  /** @nullable */
  videoText: string | null
  /** @nullable */
  performer: string | null
  /** @nullable */
  tags: string[] | null
  /** @nullable */
  metadata: ScenarioVideoMetadata
  /** @nullable */
  mediaConvertJobId: string | null
  hlsStatus: HlsStatus
  /** @nullable */
  hlsManifestS3Key: string | null
  status: VideoStatus
  /** @nullable */
  mimeType: string | null
  /** @nullable */
  fileSize: number | null
  /** @nullable */
  duration: number | null
  /** @nullable */
  customThumbnailS3Key: string | null
  /** @nullable */
  animatedThumbnailS3Key: string | null
  /** @nullable */
  thumbnailS3Key: string | null
  /** @nullable */
  description: string | null
  title: string
  s3Key: string
  tenantId: Cuid
  id: Cuid
}
